"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var doc = document;
var root = doc.documentElement || doc;
window.jQuery = jquery_1.default;
window.$ = jquery_1.default;
var $root = jquery_1.default(root);
var playerUrls = {
    live: '/player/live',
    video: '/player/kijk',
    archief: '/player/archief',
    newsbulletin: '/player/nieuwsbulletin?s_cid=nb-bulletin-homepage'
};
jquery_1.default.ajaxSetup({
    cache: false
});
$root.on('click', '.launch-player', function (e) {
    e.preventDefault();
    var el = jquery_1.default(e.currentTarget);
    var type = el.data('type');
    var audioid = el.data('id');
    var articleid = el.data('articleid');
    var url = playerUrls[type] || playerUrls.live;
    if (audioid) {
        url = "/player/audio/" + audioid + "/" + articleid;
    }
    location.href = url;
});
$root.on('change input', '[name=fragment-length]', function (e) {
    var val = this.value;
    var text = val == '60' ? '1 uur' : val + (val == 1 ? ' minuut' : ' minuten');
    jquery_1.default(this).prev('.slider-value').text(text);
});
